module.exports = __webpack_public_path__ + "img/logo3navideno.7a6bf6f3.svg";